/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeaderboardMyRankEntry } from './LeaderboardMyRankEntry';
import {
    LeaderboardMyRankEntryFromJSON,
    LeaderboardMyRankEntryFromJSONTyped,
    LeaderboardMyRankEntryToJSON,
    LeaderboardMyRankEntryToJSONTyped,
} from './LeaderboardMyRankEntry';

/**
 * 
 * @export
 * @interface LeaderboardCompetitionsMyRanksResponse
 */
export interface LeaderboardCompetitionsMyRanksResponse {
    /**
     * 
     * @type {Array<LeaderboardMyRankEntry>}
     * @memberof LeaderboardCompetitionsMyRanksResponse
     */
    ranks: Array<LeaderboardMyRankEntry>;
}

/**
 * Check if a given object implements the LeaderboardCompetitionsMyRanksResponse interface.
 */
export function instanceOfLeaderboardCompetitionsMyRanksResponse(value: object): value is LeaderboardCompetitionsMyRanksResponse {
    if (!('ranks' in value) || value['ranks'] === undefined) return false;
    return true;
}

export function LeaderboardCompetitionsMyRanksResponseFromJSON(json: any): LeaderboardCompetitionsMyRanksResponse {
    return LeaderboardCompetitionsMyRanksResponseFromJSONTyped(json, false);
}

export function LeaderboardCompetitionsMyRanksResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardCompetitionsMyRanksResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'ranks': ((json['ranks'] as Array<any>).map(LeaderboardMyRankEntryFromJSON)),
    };
}

export function LeaderboardCompetitionsMyRanksResponseToJSON(json: any): LeaderboardCompetitionsMyRanksResponse {
    return LeaderboardCompetitionsMyRanksResponseToJSONTyped(json, false);
}

export function LeaderboardCompetitionsMyRanksResponseToJSONTyped(value?: LeaderboardCompetitionsMyRanksResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ranks': ((value['ranks'] as Array<any>).map(LeaderboardMyRankEntryToJSON)),
    };
}

